import * as React from 'react'

interface AgilusCoinsIconProps {
  className?: string
  size?: number
}

const AgilusCoinsIcon = ({ className, size = 24 }: AgilusCoinsIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    {/* Bottom coin */}
    <ellipse cx="12" cy="18" rx="8" ry="3" fill="#B45309" />
    <ellipse cx="12" cy="17" rx="8" ry="3" fill="url(#coinBottom)" />
    <ellipse cx="12" cy="17" rx="6" ry="2.2" fill="none" stroke="#B45309" strokeWidth="0.4" strokeOpacity="0.3" />

    {/* Middle coin */}
    <ellipse cx="12" cy="14" rx="8" ry="3" fill="#B45309" />
    <ellipse cx="12" cy="13" rx="8" ry="3" fill="url(#coinMid)" />
    <ellipse cx="12" cy="13" rx="6" ry="2.2" fill="none" stroke="#B45309" strokeWidth="0.4" strokeOpacity="0.3" />

    {/* Top coin */}
    <ellipse cx="12" cy="10" rx="8" ry="3" fill="#B45309" />
    <ellipse cx="12" cy="9" rx="8" ry="3" fill="url(#coinTop)" />
    <ellipse cx="12" cy="9" rx="6" ry="2.2" fill="none" stroke="#D97706" strokeWidth="0.4" strokeOpacity="0.3" />

    {/* Shine on top coin */}
    <ellipse cx="9.5" cy="8.2" rx="2.5" ry="1" fill="white" opacity="0.25" />

    <defs>
      <linearGradient id="coinBottom" x1="4" y1="14" x2="20" y2="20">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
      <linearGradient id="coinMid" x1="4" y1="10" x2="20" y2="16">
        <stop offset="0%" stopColor="#FBBF24" />
        <stop offset="100%" stopColor="#F59E0B" />
      </linearGradient>
      <linearGradient id="coinTop" x1="4" y1="6" x2="20" y2="12">
        <stop offset="0%" stopColor="#FDE68A" />
        <stop offset="50%" stopColor="#FCD34D" />
        <stop offset="100%" stopColor="#FBBF24" />
      </linearGradient>
    </defs>
  </svg>
)

export default AgilusCoinsIcon
